import { render } from "./AreaItem.vue?vue&type=template&id=88176126&scoped=true"
import script from "./AreaItem.vue?vue&type=script&lang=js"
export * from "./AreaItem.vue?vue&type=script&lang=js"

import "./AreaItem.vue?vue&type=style&index=0&id=88176126&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88176126"]])

export default __exports__